import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import aboutimg1 from '../../../assets/img/about/blog/255x200/about-section-1.jpg';
import aboutimg2 from '../../../assets/img/about/blog/255x200/about-section-2.jpg';
import aboutimg3 from '../../../assets/img/about/blog/255x200/about-section-3.jpg';
import axios from 'axios';
import ReactCountryFlag from "react-country-flag"
import GoogleMapReact from 'google-map-react';
import { Icon } from '@iconify/react'
import locationIcon from '@iconify/icons-mdi/map-marker'

const LocationPin = ({ text }) => (
    <div className="justify-center">
      <Icon icon={locationIcon} className="pin-icon bg-[white] p-3 rounded-lg justify-center"  />
      <p className="text-[10px]  font-[Lato-Bold] text-[#c5aa77]">{text}</p>
    </div>
  )

class History extends Component {    
    constructor(props) {
    super(props);
   this.state = {
     dealerData:[],
    defaultProps : {
        center: {
          lat: 37.8604039,
          lng: 32.5372508
        },
        zoom: 11
      }
     }
}

async componentDidMount() {
   await this._getBlog()
}

_changeMaps= async (lat,long) => {
    this.setState({defaultProps: {
        center: {
          lat: lat,
          lng: long
        },
        zoom: 11
      } },()=> {
        console.log("sjndfjkls",this.state.defaultProps)
    })
    }


_getBlog = async () => {
try{
await axios.get(`https://buharaapi.stechomeyazilim.info:5210/getDealer/select/`)
 .then(res => {
     this.setState({dealerData: res.data })})
}
catch (error) {
 
 console.log("errorAS" + error)
}
}

    render() {
       
          const AnyReactComponent = ({ text }) => <div>{text}</div>;

        return (
            <section className="aboutus section-padding">
                        
      <div className="col-lg-12">
    
       <div className="row align-items-center">

       <div className="col-lg-8">

         <div style={{ height: '80vh', width: '100%' }} className="ex-collection-box mb-xl-20">
          <GoogleMapReact
        apiKey={"AIzaSyCm32U9QFgSBe_8pJG_2Z3G61pL6ipeQtU"}
        bootstrapURLKeys={{ key: "AIzaSyCm32U9QFgSBe_8pJG_2Z3G61pL6ipeQtU" }}
        defaultCenter={this.state.defaultProps.center}
        defaultZoom={this.state.defaultProps.zoom}>
       
      

       {this.state.dealerData.map((item, i) => ( 
       <div>
         <LocationPin
           lat={item.Dealer_Lat}
           lng={item.Dealer_Long}
           text={item.Dealer_Name}
        />

        </div>
        ))}
       
      </GoogleMapReact>

      </div>
      </div>

      <div className="col-lg-4">

                                {this.state.dealerData.map((item, i) => (
                                    <button onClick={()=> this._changeMaps(item.Dealer_Lat,item.Dealer_Long)} key={i} className="col-md-12">
                                        <div  style={{backgroundColor:'white',borderRadius:10,flexDirection:'row',margin:10}} className="row align-items-center">
                                        <h5 style={{padding:10}} className="text-light-black">{i + 1}.Bayi <span className="text-light-green">{item.Dealer_Name}</span></h5>
                                           <ReactCountryFlag  svg style={{ padding:5, width: '5em', height: '5em' }} countryCode={item.Dealer_Country} />

                                        </div>
                                    </button>
                                ))}
                            </div>
                            </div>
                            </div>

              

                <div className="container">


            

               
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="history-title mb-md-40">
                                <h2 className="text-light-black">Buhara<span className="text-light-green">Baharat</span></h2>
                                <p className="text-light-white">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis.</p>
                                <p className="text-light-white">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse.</p>
                                <Link className="btn-second btn-submit" to="#">Bize Ulaşın</Link>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="row align-items-center">
                                <div className="col-lg-6 col-sm-6 col-md-6">
                                    <div className="histry-img mb-xs-20">
                                        <img src={aboutimg3} className="img-fluid full-width" alt="Histry" />
                                    </div>
                                </div>
                                <div className="col-lg-6 col-sm-6 col-md-6">
                                    <div className="histry-img mb-xl-20">
                                        <img src={aboutimg1} className="img-fluid full-width" alt="Histry" />
                                    </div>
                                    <div className="histry-img">
                                        <img src={aboutimg2} className="img-fluid full-width" alt="Histry" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default History;